<template>
  <el-dialog
    class="banner-editor"
    :visible="bannerEditorVisible"
    @close="closeEditor"
    width="90%"
  >
    <el-form
      :model="bannerForm"
      :rules="rules"
      ref="bannerForm"
      label-width="100px"
      class="banner-ruleForm"
    >
      <el-form-item label="連結" prop="url">
        <el-input v-model="bannerForm.url"></el-input>
      </el-form-item>
      <el-form-item label="Banner" prop="image">
        <el-upload
          class="image-uploader"
          accept="image/*"
          :action="actionURL"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleImageSuccess"
          :before-upload="beforeImageUpload"
          :on-error="handleError"
        >
          <img
            v-if="bannerForm.image"
            :src="bannerForm.image"
            class="image-img"
          />
          <i v-else class="el-icon-plus image-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEditor">取 消</el-button>
      <el-button type="primary" @click="confirm">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["bannerEditorVisible", "bannerForm", "isCreate"],
  data() {
    return {
      dialogVisible: false,
      editor: undefined,
      rules: {
        url: [{ required: true, message: "請輸入連結", trigger: "blur" }],
        image: [
          { required: true, message: "請上傳Banner圖片", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    actionURL: () => process.env.VUE_APP_API_UPLOAD,
    headers() {
      return {
        Authorization: localStorage.getItem("token")
      };
    }
  },
  methods: {
    handleImageSuccess(res) {
      this.bannerForm.image = res.Location;
    },
    beforeImageUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("圖片大小不能超過 5MB!");
      }
      return isLt5M;
    },
    handleError(e) {
      let result = JSON.parse(e.message || "{}");
      this.loading = false;
      this.$message.error(`圖片上傳失敗 ${result.message || ""}`);
    },
    uploadImageSuccess(imgUrl) {
      this.dialogVisible = false;
      if (this.editor) this.editor.insertContent(`<img src="${imgUrl}">`);
    },
    onEditorInit(editor) {
      this.editor = editor;
    },
    closeEditor() {
      this.$emit("update:bannerEditorVisible", false);
    },
    confirm() {
      this.$refs["bannerForm"].validate(async valid => {
        if (valid) {
          this.$emit("saveBanner", this.bannerForm);
        } else {
          return false;
        }
      });
    }
  },
  created() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss">
.banner-editor {
  .banner-ruleForm {
    padding-right: 50px;
  }

  .image-img {
    width: 175px;
    display: block;
  }

  .image-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .image-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .image-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 175px;
    height: 175px;
    line-height: 175px;
    text-align: center;
  }
}
</style>
